// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

const productUrl = "/api/v1/products";
const productUrl2 = "/api/v2/products";

export interface FindByErpParameters extends ApiParameter {
    erpNumbers: string;
}

export interface FindByErpsParameters extends ApiParameter {
    productNumbers: string[];
}

export async function getProductByErp(parameters: FindByErpParameters) {
    try {
        const productData = await get<any>(`${productUrl}`, parameters);
        return {
            successful: true,
            product: (productData as any)?.products[0] as ProductModel,
        };
    } catch (error) {
        return {
            successful: false,
            errorMsg: error,
        };
    }
}

export async function getProductsByErps(parameters: FindByErpsParameters) {
    try {
        const productData = await get<any>(`${productUrl2}`, parameters);
        return {
            successful: true,
            products: (productData as any)?.products as ProductModel[],
        };
    } catch (error) {
        return {
            successful: false,
            errorMsg: error,
        };
    }
}
